module.exports = __webpack_public_path__ + "img/buddy_whiskers-05.e40ff789.svg";